// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"questionBox_wrapper__3Ipbq"};